import classes from './profile-section.module.scss';
import useProfile from '../../../../../Hooks/settings/profile.hook';

import Avatar from 'react-avatar';
import { Form, Input, Button, Spin, Skeleton } from 'antd';
import { useTranslation } from 'react-i18next';

export default function ProfileSection() {
  const profile = useProfile();
  const { t } = useTranslation();
  const userInfo = profile.userInfo.value;

  const fullName = userInfo ? `${userInfo.firstName} ${userInfo.lastName}` : '';
  const requiredRule = [{ required: true, message: t('common.required') }]
  const initialFields = Object.entries(profile.userInfo.value || {}).map(([key, value]) => ({
    name: key,
    value,
  }));

  return (
    <Spin spinning={profile.isLoading}>
      <Form
        name="profile"
        className={classes.form}
        fields={initialFields}
        onFinish={profile.handleSubmit}
        onFinishFailed={profile.handleSubmitFail}
        disabled={profile.isLoading}
        layout='vertical'
      >
        <div className={classes.info}>
          <div className={classes.fields}>
            <Form.Item
              label={t('settings.first-name')}
              name="firstName"
              rules={requiredRule}
            >
              <Input value={userInfo?.firstName} onChange={(e) => userInfo && profile.userInfo.set({ ...userInfo, firstName: e.target.value })} />
            </Form.Item>
            <Form.Item
              label={t('settings.last-name')}
              name="lastName"
              rules={requiredRule}
            >
              <Input value={userInfo?.lastName} onChange={(e) => userInfo && profile.userInfo.set({ ...userInfo, lastName: e.target.value })} />
            </Form.Item>
            <Form.Item label={t('common.email')} name="email">
              <Input disabled />
            </Form.Item>
          </div>
          {profile.isLoading || !userInfo
            ? <Skeleton.Avatar active={true} size={150} shape="circle" />
            : (
              <Avatar
                size={150}
                name={fullName}
                round
                color="rgb(99, 107, 116)"
              />
            )}
        </div>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            {t('settings.save-changes')}
          </Button>
        </Form.Item>
      </Form>
    </Spin>
  );
};
